import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import CampoSenha from './CampoSenha';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

interface EntrarAbaProps {
  email: string;
  onEmailChange: (value: string) => void;
  aviso?: string | null;
  onEntrar: (email: string, senha: string) => Promise<{ mensagem?: string } | null>;
}

export default function EntrarAba({ email, onEmailChange, aviso, onEntrar }: EntrarAbaProps) {
  const [senha, setSenha] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const emailLimpo = email.trim();

    if (!emailLimpo) {
      setError('Digite seu e-mail.');
      return;
    }
    if (!EMAIL_REGEX.test(emailLimpo)) {
      setError('Digite um e-mail válido, como maria@gmail.com');
      return;
    }
    if (!senha) {
      setError('Digite sua senha.');
      return;
    }

    setError(null);
    setEnviando(true);
    const resultado = await onEntrar(emailLimpo, senha);
    setEnviando(false);
    if (resultado?.mensagem) setError(resultado.mensagem);
  };

  return (
    <form onSubmit={handleSubmit} noValidate className="animate-fade-in">
      {aviso && (
        <div className="mb-4 rounded-md border border-primary-200 bg-primary-50 px-3 py-2 text-sm text-primary-800">
          {aviso}
        </div>
      )}

      <div>
        <label htmlFor="entrar-email" className="block text-base font-medium text-foreground-950">
          Seu e-mail <span className="text-danger-600">*</span>
        </label>
        <input
          id="entrar-email"
          name="email"
          type="email"
          inputMode="email"
          autoComplete="email"
          placeholder="maria@gmail.com"
          value={email}
          onChange={(e) => onEmailChange(e.target.value)}
          className="mt-1 w-full border-0 border-b border-secondary-300 bg-transparent px-0 py-2 text-[15px] text-foreground-950 outline-none transition-colors placeholder:text-secondary-400 focus:border-b-2 focus:border-primary-500"
        />
      </div>

      <div className="mt-4">
        <CampoSenha
          id="entrar-senha"
          name="senha"
          label="Sua senha"
          value={senha}
          onChange={setSenha}
          required
          autoComplete="current-password"
        />
      </div>

      <div className="mt-2 flex justify-end">
        <Link
          to="/recuperar-senha"
          className="cursor-pointer whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-800"
        >
          Esqueci minha senha
        </Link>
      </div>

      {error && (
        <p className="mt-3 text-sm text-danger-600" role="alert">
          {error}
        </p>
      )}

      <button
        type="submit"
        disabled={enviando}
        className="mt-6 flex h-12 w-full items-center justify-center rounded-md bg-primary-500 text-[15px] font-medium text-background-50 transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:bg-secondary-200 disabled:text-secondary-400 whitespace-nowrap"
      >
        {enviando ? 'Entrando...' : 'Entrar'}
      </button>

      <p className="mt-3 text-center text-xs leading-relaxed text-secondary-500">
        Esqueceu a senha? Fale com a organização do seu evento ou com o Se Liga pelo WhatsApp que te
        mandamos um link para criar uma nova senha.
      </p>
    </form>
  );
}